import { UpsellPageBanner } from "@redotech/redo-conversion-core-common/upsell-page/upsell-page-db-validator";
import { TextSize } from "@redotech/redo-conversion-core-common/upsell-page/upsell-page-types";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { SpacingValue } from "@redotech/redo-web/theme/box";
import { TextSizeValue } from "@redotech/redo-web/theme/typography";
import { assertNever } from "@redotech/util/type";

export const bannerTextSize = (size: TextSize): TextSizeValue => {
  switch (size) {
    case TextSize.SMALL:
      return "xs";
    case TextSize.MEDIUM:
      return "sm";
    case TextSize.LARGE:
      return "md";
    case TextSize.XLARGE:
      return "lg";
    default:
      assertNever(size);
  }
};

export const PostPurchaseBanner = function PostPurchaseBanner({
  banner,
  px = "none",
}: {
  banner: UpsellPageBanner;
  px?: SpacingValue;
}) {
  const titleSizeValue = bannerTextSize(banner.titleSize);
  const supportingTextSizeValue = bannerTextSize(banner.supportingTextSize);

  if (!banner.showBanner) {
    return null;
  }

  return (
    <Flex
      align="center"
      bgColor="secondary"
      borderBottomWidth="1px"
      borderColor="primary"
      borderStyle="solid"
      borderTopWidth="1px"
      dir="column"
      grow={1}
      px={px}
      py="lg"
    >
      <Text fontSize={titleSizeValue} fontWeight="medium">
        {banner.title}
      </Text>
      <Text fontSize={supportingTextSizeValue} textAlign="center">
        {banner.supportingText}
      </Text>
    </Flex>
  );
};
